var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import axios from 'axios';
import locale from 'element-ui/lib/locale';
import elementUiLocaleLangEn from 'element-ui/lib/locale/lang/en';
import elementUiLocaleLangFr from 'element-ui/lib/locale/lang/fr';
import elementUiLocale from 'element-ui/lib/locale';
import { BaseModule } from './../commons/BaseModule';
import * as Cookies from 'js-cookie';
var languageList = [
    'de',
    'en',
    'es',
    'fr',
    'nl',
    'pt',
];
var LocalizationModule = (function (_super) {
    __extends(LocalizationModule, _super);
    function LocalizationModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadedLanguages = [];
        return _this;
    }
    LocalizationModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Vue.use(VueI18n);
            var config = Vue.config;
            config.lang = 'en';
            locale.use(en);
            _this.i18n = new VueI18n({
                locale: 'en',
                fallbackLocale: 'en',
                silentTranslationWarn: process.env.NODE_ENV === 'production',
                silentFallbackWarn: true,
                messages: {
                    en: en
                }
            });
            _this.loadedLanguages.push('en');
            elementUiLocale.use(elementUiLocaleLangEn);
            options.appModule.appOptions.i18n = _this.i18n;
            resolve(true);
        });
    };
    LocalizationModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    LocalizationModule.prototype.getLocale = function () {
        return this.i18n.locale;
    };
    LocalizationModule.prototype.setLocale = function (locale) {
        return __awaiter(this, void 0, void 0, function () {
            var messages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('setLocale', locale, this.getLocale());
                        if (!locale)
                            return [2];
                        if (this.getLocale() == locale)
                            return [2];
                        if (this.loadedLanguages.includes(locale)) {
                            this._setLocale(locale);
                            return [2];
                        }
                        if (languageList.indexOf(locale.toLowerCase()) < 0)
                            return [2];
                        return [4, import("./locales/".concat(locale))];
                    case 1:
                        messages = _a.sent();
                        console.log('new locale messages', messages);
                        this.i18n.setLocaleMessage(locale, messages);
                        this.loadedLanguages.push(locale);
                        this._setLocale(locale);
                        return [2];
                }
            });
        });
    };
    LocalizationModule.prototype._setLocale = function (locale) {
        this.i18n.locale = locale;
        axios.defaults.headers.common['Accept-Language'] = locale;
        document.querySelector('html').setAttribute('lang', locale);
        elementUiLocale.use(locale === 'en' ? elementUiLocaleLangEn : elementUiLocaleLangFr);
        Cookies.set('Language', locale === 'en' ? 'en' : locale);
    };
    return LocalizationModule;
}(BaseModule));
export default LocalizationModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/localization/index.ts
// module id = htp+
// module chunks = 10